import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { useRef } from 'react';
import { useReactNodeView } from '../utils/ReactNodeView';
import styled from 'styled-components';
import { CompaniesIcon } from 'foundations-assets/icons/components/CompaniesIcon';
import { ContactsIcon } from 'foundations-assets/icons/components/ContactsIcon';
import { MeetingsIcon } from 'foundations-assets/icons/components/MeetingsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const personalizationTokenIconMap = {
  companies: CompaniesIcon,
  contacts: ContactsIcon,
  meetings: MeetingsIcon
};
const StyledToken = styled.span.withConfig({
  displayName: "PersonalizationTokenView__StyledToken",
  componentId: "sc-6jdl75-0"
})(["align-items:center;background-color:", ";border:", " solid ", ";border-radius:", ";color:", ";cursor:default;display:inline-flex;line-height:1;margin:", ";padding:", ";vertical-align:middle;user-select:text;white-space:nowrap;inline-size:auto;"], ({
  theme,
  backgroundColor
}) => backgroundColor || theme.color['fill-info-subtle'], ({
  theme
}) => theme.borderWidth['100'], ({
  theme,
  borderColor
}) => borderColor || theme.color['border-core-default'], ({
  theme
}) => theme.borderRadius['100'], ({
  theme,
  fontColor
}) => fontColor || theme.color['fill-info-default'], ({
  theme
}) => theme.space['0'], ({
  theme,
  padding
}) => padding || `${theme.space['100']} ${theme.space['200']}`);
export function PersonalizationTokenView() {
  const {
    node
  } = useReactNodeView();
  const attrs = useRef(node ? node.attrs : {});
  const tokenIconKey = attrs.current.tokenStyles.tokenIconKey;
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(StyledToken, {
      backgroundColor: attrs.current.tokenStyles.backgroundColor,
      borderColor: attrs.current.tokenStyles.borderColor,
      fontColor: attrs.current.tokenStyles.fontColor,
      padding: attrs.current.tokenStyles.padding,
      "data-test-id": "ProseMirror__personalizationToken",
      children: [personalizationTokenIconMap[tokenIconKey] && /*#__PURE__*/_jsx(IconHolder, {
        icon: personalizationTokenIconMap[tokenIconKey],
        marginInlineEnd: "200",
        padding: "0"
      }), attrs.current.displayText || attrs.current.tokenKey]
    })
  );
}
PersonalizationTokenView.displayName = 'PersonalizationTokenView';
export function personalizationTokenViewUpdateFn({
  previousNode,
  node
}) {
  if (previousNode.attrs.tokenKey !== node.attrs.tokenKey) {
    return false;
  }
  return true;
}